import Paper from '@mui/material/Paper';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import WarningAmberOutlined from '@mui/icons-material/WarningAmberOutlined';
import PropTypes from 'prop-types';
import { Regions, RegionValues } from '../../scripts/regions';
import { ClinicalSpecialtyAndDistinction } from '../../scripts/specialty';

const ResourceSelector = ({
	specialtyAndDistinction = null,
	setSpecialtyAndDistinction,
	region = null,
	setRegion,
}) => (
	<Paper
		sx={{
			width: 247,
			display: 'flex',
			flexDirection: 'column',
			gap: 0,
		}}
	>
		{/* Warning Alert */}
		<Alert
			severity='warning'
			icon={<WarningAmberOutlined />}
			style={{
				marginBottom: 0,
				backgroundColor: '#fff4e5',
				color: '#663c00',
			}}
		>
			<AlertTitle sx={{ mb: 1 }}>FOR TESTING ONLY</AlertTitle>
			View the resources for a specific specialty and region.
		</Alert>

		{/* SpecialtyAndDistinctions Dropdown */}
		<FormControl sx={{ m: 2 }}>
			<InputLabel>Speciality</InputLabel>
			<Select
				value={specialtyAndDistinction || ''}
				onChange={e =>
					setSpecialtyAndDistinction(
						e.target.value === 'clear' ? null : e.target.value
					)
				}
				label='Speciality'
			>
				<MenuItem key='clear' value='clear'>
					No Selection
				</MenuItem>
				{ClinicalSpecialtyAndDistinction.map((item, index) => (
					<MenuItem key={item.key} value={index + 1}>
						{item.label}
					</MenuItem>
				))}
			</Select>
		</FormControl>

		{/* Region Dropdown - MUI large list behavior: https://github.com/mui/material-ui/issues/34656 */}
		<FormControl sx={{ mt: 0, mb: 2, ml: 2, mr: 2 }}>
			<InputLabel>Region</InputLabel>
			<Select
				value={region || ''}
				onChange={e =>
					setRegion(
						e.target.value === 'clear' ? null : e.target.value
					)
				}
				label='Region'
				MenuProps={{
					PaperProps: {
						sx: {
							maxHeight: 300,
							overflowY: 'auto',
						},
					},
				}}
			>
				<MenuItem key='clear' value='clear'>
					No Selection
				</MenuItem>
				{Regions.map(item => (
					<MenuItem key={item.key} value={RegionValues[item.key]}>
						{item.label}
					</MenuItem>
				))}
			</Select>
		</FormControl>
	</Paper>
);

ResourceSelector.propTypes = {
	specialtyAndDistinction: PropTypes.number,
	setSpecialtyAndDistinction: PropTypes.func.isRequired,
	region: PropTypes.number,
	setRegion: PropTypes.func.isRequired,
};

export default ResourceSelector;
